import { LegalLayout } from "@/components/LegalLayout";

export default function RefundPage() {
  return (
    <LegalLayout title="Refund & Cancellation Policy" lastUpdated="February 2026" testId="refund-page">
      <p>
        This Refund &amp; Cancellation Policy applies to all subscription purchases
        made on <strong>Brimi AI</strong> (operated by Brajesh Chaudhary,
        1 MP Road, Tundla, Dist. Firozabad, UP — 283204).
      </p>

      <h2>1. Try before you pay</h2>
      <p>
        Every new user gets a <strong>20-day free trial</strong> with full feature
        access. No payment details are required to start the trial. We strongly
        encourage you to use the trial period to evaluate whether Brimi AI is the
        right fit for you before subscribing.
      </p>

      <h2>2. No refunds on paid subscriptions</h2>
      <p>
        Because our subscriptions unlock immediate and unlimited access to
        AI-generated tutoring, notes and quizzes — costs that we incur on a
        per-message basis from our AI providers — <strong>all subscription
        payments are non-refundable</strong> once a plan has been purchased.
      </p>
      <p>
        This applies to both <strong>monthly (₹299)</strong> and{" "}
        <strong>yearly (₹2,499)</strong> plans, whether or not the Service is
        actively used during the paid period.
      </p>

      <h2>3. Cancel anytime — no auto-renewal</h2>
      <p>
        Brimi AI subscriptions are <strong>one-time prepaid</strong> and do
        <strong> not auto-renew</strong>. You will not be charged again
        automatically at the end of your current period. To stop using Brimi AI,
        simply let your current subscription expire — you will not be billed
        again.
      </p>
      <p>
        You will continue to enjoy full access until the end of your current
        paid period.
      </p>

      <h2>4. Failed or duplicate payments</h2>
      <p>
        If you were charged but did not receive access (e.g. payment captured but
        subscription not activated due to a technical error), or if you were
        accidentally charged twice for the same plan, you are entitled to a full
        refund of the affected transaction.
      </p>
      <p>
        Email <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a> within
        <strong> 7 days</strong> of the transaction with your Razorpay payment ID
        and registered email. Verified refunds are processed back to the original
        payment method within <strong>5–10 business days</strong>.
      </p>

      <h2>5. Account termination by us</h2>
      <p>
        If we terminate your account for violation of our{" "}
        <a href="/terms">Terms of Service</a> (e.g. abuse, fraud, account sharing),
        no refund will be issued for the unused portion of your subscription.
      </p>

      <h2>6. How to cancel / request a refund-eligible review</h2>
      <ol>
        <li>Email <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a> from the email address registered on your Brimi AI account.</li>
        <li>Include your Razorpay Payment ID (begins with <code>pay_…</code>) and the reason for your request.</li>
        <li>Our team will respond within 1 business day and resolve eligible cases within 5–10 business days.</li>
      </ol>

      <h2>7. Contact</h2>
      <p>
        Brajesh Chaudhary (Proprietor)<br />
        Email: <a href="mailto:brajeshc56@gmail.com">brajeshc56@gmail.com</a><br />
        Phone: +91 79836 33563<br />
        Address: 1 MP Road, Tundla, Dist. Firozabad, UP — 283204, India
      </p>
    </LegalLayout>
  );
}
